/**
 * 输入内容类型
 */
const INPUT_TYPES = {
    RECORD: 0,
    ALBUM: 1,
    CAMERA: 2,
    REPORT: 3
};

Component({
    /**
     * 组件的属性列表
     */
    properties: {
        resetAllTypes: {
            type: Boolean,
            value: false,
            observer: function(isResetAll) {
                // 恢复初始态 全部未选中
                if (isResetAll) {
                    this.setData({
                        selectIndex: -1
                    });
                }
            }
        },
        voiceStatus: {
            type: Boolean,
            value: true
        },
        imageStatus: {
            type: Boolean,
            value: true
        }
    },

    /**
     * 组件的初始数据
     */
    data: {
        selectIndex: -1
    },

    /**
     * 组件的方法列表
     */
    methods: {
        /**
         * 录音
         */
        handleRecordPanel: function() {
            if (!this.data.voiceStatus) {
                return false;
            }
            const activeRecordPanel =
                this.data.selectIndex === 0 ? false : true;
            const selectIndexNew = activeRecordPanel ? 0 : -1;
            this.setData({
                selectIndex: selectIndexNew
            });
            this.triggerEvent("activeRecordPanel", activeRecordPanel);
        },
        handleImagePanel: function() {
            if (!this.data.imageStatus) {
                return false;
            }
            const activeImagePanel = this.data.selectIndex === 1 ? false : true;
            const selectIndexNew = activeImagePanel ? 1 : -1;
            const { selectIndex } = this.data;
            this.setData({
                selectIndex: selectIndexNew
            });
            this.triggerEvent("activeImagePanel", activeImagePanel);
        }
    }
});
